import _slicedToArray from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _possibleConstructorReturn from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/fieldsense-web/fieldsense-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import LRUCache from 'lru-cache';
import { BaseSource } from './basesource';
import { AbortError, AggregateError, wait, zip } from '../utils';
var Block = /*#__PURE__*/function () {
  /**
   *
   * @param {number} offset
   * @param {number} length
   * @param {ArrayBuffer} [data]
   */
  function Block(offset, length) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, Block);
    this.offset = offset;
    this.length = length;
    this.data = data;
  }

  /**
   * @returns {number} the top byte border
   */
  _createClass(Block, [{
    key: "top",
    get: function get() {
      return this.offset + this.length;
    }
  }]);
  return Block;
}();
var BlockGroup =
/**
 *
 * @param {number} offset
 * @param {number} length
 * @param {number[]} blockIds
 */
function BlockGroup(offset, length, blockIds) {
  _classCallCheck(this, BlockGroup);
  this.offset = offset;
  this.length = length;
  this.blockIds = blockIds;
};
export var BlockedSource = /*#__PURE__*/function (_BaseSource) {
  _inherits(BlockedSource, _BaseSource);
  /**
   *
   * @param {Source} source The underlying source that shall be blocked and cached
   * @param {object} options
   */
  function BlockedSource(source) {
    var _this;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$blockSize = _ref.blockSize,
      blockSize = _ref$blockSize === void 0 ? 65536 : _ref$blockSize,
      _ref$cacheSize = _ref.cacheSize,
      cacheSize = _ref$cacheSize === void 0 ? 100 : _ref$cacheSize;
    _classCallCheck(this, BlockedSource);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlockedSource).call(this));
    _this.source = source;
    _this.blockSize = blockSize;
    _this.blockCache = new LRUCache({
      max: cacheSize
    });

    // mapping blockId -> Block instance
    _this.blockRequests = new Map();

    // set of blockIds missing for the current requests
    _this.blockIdsToFetch = new Set();
    return _this;
  }
  _createClass(BlockedSource, [{
    key: "fetch",
    /**
     *
     * @param {basesource/Slice[]} slices
     */
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(slices, signal) {
        var cachedBlocks, blockRequests, missingBlockIds, _iterator, _step, _step$value, offset, length, top, fileSize, firstBlockOffset, current, _blockId2, _iterator2, _step2, _blockId3, _block, cachedBlock, results, retriedBlockRequests, _iterator3, _step3, _step3$value, _blockId, result, rejected, reason, _iterator4, _step4, blockId, block, values, requiredBlocks, _iterator5, _step5, _step5$value, _blockId4, _block2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cachedBlocks = new Map();
              blockRequests = new Map();
              missingBlockIds = new Set();
              _iterator = _createForOfIteratorHelper(slices);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _step.value, offset = _step$value.offset, length = _step$value.length;
                  top = offset + length;
                  fileSize = this.fileSize;
                  if (fileSize !== null) {
                    top = Math.min(top, fileSize);
                  }
                  firstBlockOffset = Math.floor(offset / this.blockSize) * this.blockSize; // chunk the current slice into blocks
                  for (current = firstBlockOffset; current < top; current += this.blockSize) {
                    // check if the block is cached, being requested or still missing
                    _blockId2 = Math.floor(current / this.blockSize);
                    if (this.blockCache.has(_blockId2)) {
                      cachedBlocks.set(_blockId2, this.blockCache.get(_blockId2));
                    } else if (this.blockRequests.has(_blockId2)) {
                      blockRequests.set(_blockId2, this.blockRequests.get(_blockId2));
                    } else if (this.blockIdsToFetch.has(_blockId2)) {
                      missingBlockIds.add(_blockId2);
                    } else {
                      this.blockIdsToFetch.add(_blockId2);
                      missingBlockIds.add(_blockId2);
                    }
                  }
                }

                // allow additional block requests to accumulate
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context.next = 7;
              return wait();
            case 7:
              this.fetchBlocks(signal);
              _iterator2 = _createForOfIteratorHelper(missingBlockIds);
              _context.prev = 9;
              _iterator2.s();
            case 11:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 26;
                break;
              }
              _blockId3 = _step2.value;
              _block = this.blockRequests.get(_blockId3);
              cachedBlock = this.blockCache.get(_blockId3);
              if (!_block) {
                _context.next = 19;
                break;
              }
              blockRequests.set(_blockId3, _block);
              _context.next = 24;
              break;
            case 19:
              if (!cachedBlock) {
                _context.next = 23;
                break;
              }
              cachedBlocks.set(_blockId3, cachedBlock);
              _context.next = 24;
              break;
            case 23:
              throw new Error("Block ".concat(_blockId3, " is not in the block requests"));
            case 24:
              _context.next = 11;
              break;
            case 26:
              _context.next = 31;
              break;
            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](9);
              _iterator2.e(_context.t0);
            case 31:
              _context.prev = 31;
              _iterator2.f();
              return _context.finish(31);
            case 34:
              _context.next = 36;
              return Promise.allSettled(Array.from(blockRequests.values()));
            case 36:
              results = _context.sent;
              if (!results.some(function (result) {
                return result.status === 'rejected';
              })) {
                _context.next = 65;
                break;
              }
              retriedBlockRequests = new Set();
              _iterator3 = _createForOfIteratorHelper(zip(blockRequests.keys(), results));
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _step3$value = _slicedToArray(_step3.value, 2), _blockId = _step3$value[0], result = _step3$value[1];
                  rejected = result.rejected, reason = result.reason;
                  if (rejected) {
                    // push some blocks back to the to-fetch list if they were
                    // aborted, but only when a different signal was used
                    if (reason.name === 'AbortError' && reason.signal !== signal) {
                      this.blockIdsToFetch.add(_blockId);
                      retriedBlockRequests.add(_blockId);
                    }
                  }
                }

                // start the retry of some blocks if required
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              if (!(this.blockIdsToFetch.length > 0)) {
                _context.next = 65;
                break;
              }
              this.fetchBlocks(signal);
              _iterator4 = _createForOfIteratorHelper(retriedBlockRequests);
              _context.prev = 44;
              _iterator4.s();
            case 46:
              if ((_step4 = _iterator4.n()).done) {
                _context.next = 54;
                break;
              }
              blockId = _step4.value;
              block = this.blockRequests.get(blockId);
              if (block) {
                _context.next = 51;
                break;
              }
              throw new Error("Block ".concat(blockId, " is not in the block requests"));
            case 51:
              blockRequests.set(blockId, block);
            case 52:
              _context.next = 46;
              break;
            case 54:
              _context.next = 59;
              break;
            case 56:
              _context.prev = 56;
              _context.t1 = _context["catch"](44);
              _iterator4.e(_context.t1);
            case 59:
              _context.prev = 59;
              _iterator4.f();
              return _context.finish(59);
            case 62:
              _context.next = 64;
              return Promise.allSettled(Array.from(blockRequests.values()));
            case 64:
              results = _context.sent;
            case 65:
              if (!results.some(function (result) {
                return result.status === 'rejected';
              })) {
                _context.next = 69;
                break;
              }
              if (!(signal && signal.aborted)) {
                _context.next = 68;
                break;
              }
              throw new AbortError('Request was aborted');
            case 68:
              throw new AggregateError(results.filter(function (result) {
                return result.status === 'rejected';
              }).map(function (result) {
                return result.reason;
              }), 'Request failed');
            case 69:
              // extract the actual block responses
              values = results.map(function (result) {
                return result.value;
              }); // create a final Map, with all required blocks for this request to satisfy
              requiredBlocks = new Map(zip(Array.from(blockRequests.keys()), values));
              _iterator5 = _createForOfIteratorHelper(cachedBlocks);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  _step5$value = _slicedToArray(_step5.value, 2), _blockId4 = _step5$value[0], _block2 = _step5$value[1];
                  requiredBlocks.set(_blockId4, _block2);
                }

                // TODO: satisfy each slice
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              return _context.abrupt("return", this.readSliceData(slices, requiredBlocks));
            case 74:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[9, 28, 31, 34], [44, 56, 59, 62]]);
      }));
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
    /**
     *
     * @param {AbortSignal} signal
     */
  }, {
    key: "fetchBlocks",
    value: function fetchBlocks(signal) {
      var _this2 = this;
      // check if we still need to
      if (this.blockIdsToFetch.size > 0) {
        var groups = this.groupBlocks(this.blockIdsToFetch);

        // start requesting slices of data
        var groupRequests = this.source.fetch(groups, signal);
        var _loop = function _loop(groupIndex) {
          var group = groups[groupIndex];
          var _iterator6 = _createForOfIteratorHelper(group.blockIds),
            _step6;
          try {
            var _loop2 = function _loop2() {
              var blockId = _step6.value;
              // make an async IIFE for each block
              var blockRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                var response, blockOffset, o, t, data, block;
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.prev = 0;
                      _context2.next = 3;
                      return groupRequests;
                    case 3:
                      _context2.t0 = groupIndex;
                      response = _context2.sent[_context2.t0];
                      blockOffset = blockId * _this2.blockSize;
                      o = blockOffset - response.offset;
                      t = Math.min(o + _this2.blockSize, response.data.byteLength);
                      data = response.data.slice(o, t);
                      block = new Block(blockOffset, data.byteLength, data);
                      _this2.blockCache.set(blockId, block);
                      return _context2.abrupt("return", block);
                    case 14:
                      _context2.prev = 14;
                      _context2.t1 = _context2["catch"](0);
                      if (_context2.t1.name === 'AbortError') {
                        // store the signal here, we need it to determine later if an
                        // error was caused by this signal
                        _context2.t1.signal = signal;
                      }
                      throw _context2.t1;
                    case 18:
                      _context2.prev = 18;
                      _this2.blockRequests.delete(blockId);
                      return _context2.finish(18);
                    case 21:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2, null, [[0, 14, 18, 21]]);
              }))();
              _this2.blockRequests.set(blockId, blockRequest);
            };
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        };
        for (var groupIndex = 0; groupIndex < groups.length; ++groupIndex) {
          _loop(groupIndex);
        }
        this.blockIdsToFetch.clear();
      }
    }
    /**
     *
     * @param {Set} blockIds
     * @returns {BlockGroup[]}
     */
  }, {
    key: "groupBlocks",
    value: function groupBlocks(blockIds) {
      var sortedBlockIds = Array.from(blockIds).sort(function (a, b) {
        return a - b;
      });
      if (sortedBlockIds.length === 0) {
        return [];
      }
      var current = [];
      var lastBlockId = null;
      var groups = [];
      var _iterator7 = _createForOfIteratorHelper(sortedBlockIds),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var blockId = _step7.value;
          if (lastBlockId === null || lastBlockId + 1 === blockId) {
            current.push(blockId);
            lastBlockId = blockId;
          } else {
            groups.push(new BlockGroup(current[0] * this.blockSize, current.length * this.blockSize, current));
            current = [blockId];
            lastBlockId = blockId;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      groups.push(new BlockGroup(current[0] * this.blockSize, current.length * this.blockSize, current));
      return groups;
    }
    /**
     *
     * @param {Slice[]} slices
     * @param {Map} blocks
     */
  }, {
    key: "readSliceData",
    value: function readSliceData(slices, blocks) {
      var _this3 = this;
      return slices.map(function (slice) {
        var top = slice.offset + slice.length;
        var blockIdLow = Math.floor(slice.offset / _this3.blockSize);
        var blockIdHigh = Math.floor((slice.offset + slice.length) / _this3.blockSize);
        var sliceData = new ArrayBuffer(slice.length);
        var sliceView = new Uint8Array(sliceData);
        for (var blockId = blockIdLow; blockId <= blockIdHigh; ++blockId) {
          var block = blocks.get(blockId);
          var delta = block.offset - slice.offset;
          var topDelta = block.top - top;
          var blockInnerOffset = 0;
          var rangeInnerOffset = 0;
          var usedBlockLength = void 0;
          if (delta < 0) {
            blockInnerOffset = -delta;
          } else if (delta > 0) {
            rangeInnerOffset = delta;
          }
          if (topDelta < 0) {
            usedBlockLength = block.length - blockInnerOffset;
          } else {
            usedBlockLength = top - block.offset - blockInnerOffset;
          }
          var blockView = new Uint8Array(block.data, blockInnerOffset, usedBlockLength);
          sliceView.set(blockView, rangeInnerOffset);
        }
        return sliceData;
      });
    }
  }, {
    key: "fileSize",
    get: function get() {
      return this.source.fileSize;
    }
  }]);
  return BlockedSource;
}(BaseSource);